import {
  CurrencyPipe,
  NgClass,
  NgOptimizedImage,
  SlicePipe,
} from '@angular/common'
import { Component, SecurityContext, inject, input, model } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser'

import { TranslatePipe } from '@ngx-translate/core'
import { NgArrayPipesModule, NgMathPipesModule } from 'ngx-pipes'

import type { ProductDto } from '../../../../api/responses'
import { ProductsService } from '../../../../services/product/products.service'
import { NumericalInputComponent } from '../numerical-input/numerical-input.component'

@Component({
  selector: 'dhp-product-card',
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
  imports: [
    NgClass,
    NgOptimizedImage,
    FormsModule,
    NumericalInputComponent,
    SlicePipe,
    CurrencyPipe,
    TranslatePipe,
    NgArrayPipesModule,
    NgMathPipesModule,
  ],
})
export class ProductCardComponent {
  product = input.required<ProductDto>()
  row = input<boolean>(false)
  minSelected = input<number | undefined>(undefined)
  seats = model<number>(0)
  customerCostReference = model<string | undefined>(undefined)

  private readonly productService = inject(ProductsService)
  private readonly domSanitizer = inject(DomSanitizer)

  onChange(users: number): void {
    this.seats.set(users)
  }

  getPrice(): number {
    return this.productService.getPrice(
      this.product().product_options.docs,
      Math.max(this.seats(), 1)
    )
  }

  onCustomerCostReferenceChange(value: string): void {
    this.customerCostReference.set(value.trim())
  }

  sanitize(input: string): string | null {
    return this.domSanitizer.sanitize(SecurityContext.HTML, input)
  }
}
